/**
 * FAQ Section - Optimized Performance
 * Features: Accessibility, Keyboard Navigation, Zero Layout Shift
 */

(function() {
  'use strict';

  // تجنب تشغيل السكريبت أكثر من مرة
  if (window.faqInitialized) return;
  window.faqInitialized = true;

  class FAQAccordion {
    constructor(container) {
      this.container = container;
      this.items = Array.from(container.querySelectorAll('.faq-item'));
      this.activeItem = null;
      this.init();
    }

    init() {
      // إضافة Event Listeners بكفاءة
      this.items.forEach(item => {
        const btn = item.querySelector('.faq-question');
        if (!btn) return;

        // Click event
        btn.addEventListener('click', (e) => this.handleToggle(item, e));

        // Keyboard navigation
        btn.addEventListener('keydown', (e) => this.handleKeyboard(e, item));
      });

      // حساب الارتفاع مرة واحدة فقط عند التحميل
      this.calculateHeights();
    }

    calculateHeights() {
      // تخزين الارتفاعات لتجنب reflow متكرر
      this.items.forEach(item => {
        const answer = item.querySelector('.faq-answer');
        const inner = item.querySelector('.faq-answer-inner');
        if (answer && inner) {
          answer.dataset.height = inner.scrollHeight + 'px';
        }
      });
    }

    handleToggle(item, event) {
      event.preventDefault();
      
      const isActive = item.classList.contains('active');
      
      // إغلاق العنصر النشط السابق
      if (this.activeItem && this.activeItem !== item) {
        this.closeItem(this.activeItem);
      }

      // تبديل العنصر الحالي
      if (isActive) {
        this.closeItem(item);
      } else {
        this.openItem(item);
      }
    }

    openItem(item) {
      const btn = item.querySelector('.faq-question');
      const icon = item.querySelector('.faq-icon');
      const answer = item.querySelector('.faq-answer');
      
      if (!btn || !answer) return;

      // استخدام requestAnimationFrame لتحسين الأداء
      requestAnimationFrame(() => {
        item.classList.add('active');
        btn.setAttribute('aria-expanded', 'true');
        answer.removeAttribute('hidden');
        answer.style.maxHeight = answer.dataset.height || '2000px';
        if (icon) icon.textContent = '×';
        
        this.activeItem = item;
      });
    }

    closeItem(item) {
      const btn = item.querySelector('.faq-question');
      const icon = item.querySelector('.faq-icon');
      const answer = item.querySelector('.faq-answer');
      
      if (!btn || !answer) return;

      requestAnimationFrame(() => {
        item.classList.remove('active');
        btn.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = '0';
        if (icon) icon.textContent = '+';
        
        // إخفاء العنصر بعد انتهاء الانيميشن
        setTimeout(() => {
          if (!item.classList.contains('active')) {
            answer.setAttribute('hidden', '');
          }
        }, 400);
        
        if (this.activeItem === item) {
          this.activeItem = null;
        }
      });
    }

    handleKeyboard(event, item) {
      const key = event.key;
      const currentIndex = this.items.indexOf(item);

      switch(key) {
        case 'Enter':
        case ' ':
          event.preventDefault();
          this.handleToggle(item, event);
          break;
        
        case 'ArrowDown':
          event.preventDefault();
          this.focusNextItem(currentIndex);
          break;
        
        case 'ArrowUp':
          event.preventDefault();
          this.focusPrevItem(currentIndex);
          break;
        
        case 'Home':
          event.preventDefault();
          this.focusItem(0);
          break;
        
        case 'End':
          event.preventDefault();
          this.focusItem(this.items.length - 1);
          break;
      }
    }

    focusNextItem(currentIndex) {
      const nextIndex = (currentIndex + 1) % this.items.length;
      this.focusItem(nextIndex);
    }

    focusPrevItem(currentIndex) {
      const prevIndex = currentIndex === 0 ? this.items.length - 1 : currentIndex - 1;
      this.focusItem(prevIndex);
    }

    focusItem(index) {
      const item = this.items[index];
      const btn = item?.querySelector('.faq-question');
      if (btn) btn.focus();
    }
  }

  // تهيئة جميع أقسام FAQ في الصفحة
  function initFAQSections() {
    const containers = document.querySelectorAll('.faq-section');
    containers.forEach(container => {
      new FAQAccordion(container);
    });
  }

  // تشغيل السكريبت
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQSections);
  } else {
    initFAQSections();
  }

  // إعادة حساب الارتفاعات عند تغيير حجم النافذة (debounced)
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const containers = document.querySelectorAll('.faq-section');
      containers.forEach(container => {
        const items = container.querySelectorAll('.faq-item');
        items.forEach(item => {
          const answer = item.querySelector('.faq-answer');
          const inner = item.querySelector('.faq-answer-inner');
          if (answer && inner) {
            answer.dataset.height = inner.scrollHeight + 'px';
            if (item.classList.contains('active')) {
              answer.style.maxHeight = answer.dataset.height;
            }
          }
        });
      });
    }, 250);
  });

})();